<template>
  <div id="EquipmentCurrentStatus">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>

    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Shop Purchase Orders</div>
          <div class="web-action-btn btn-groups text-right">
              <!-- Button for Clear Cache -->
              <!-- <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'shopPurchaseOrderReport'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
            <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
            <section class="bg-white data-table">
              <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange" :moduleName="'shopPurchaseOrderReport'" :position="'top'">
              </custom-pagination>

              <vue-good-table
                      mode="remote"
                      ref="shopPurchaseOrderReport"
                      title="Shop Purchase Order Report"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      @on-select-all="onSelectAll"
                      @on-selected-rows-change="selectionChanged"
                      :totalRows="totalRecords"
                      :columns="userColumns"
                      :rows="rows"
                      :paginationOptions="{
                          enabled: false,
                          position: 'both',
                          perPage: perPage,
                          dropdownAllowAll: false,
                          setCurrentPage:listCurrentPage,
                          perPageDropdown:dropDownPerPage,
                      }"
                      :select-options="{
                          enabled: false,
                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                          selectionInfoClass: 'custom-class',
                          selectionText: 'rows selected',
                          clearSelectionText: 'clear',
                      }"
                      :search-options="{
                      enabled: false,
                      }"

                      >
                  </vue-good-table>
              <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange"
                  :moduleName="'shopPurchaseOrderReport'">
              </custom-pagination>
            </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
            <div class="bg-white text-center">
                <h1>
                    Oops!</h1>
                <h2>
                    403 </h2>
                <div class="error-details">
                    Sorry!, You don't have permission to access this page.
                </div>
            </div>
        </div>
      </template>
      <template v-else>
          <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

export default {

  name: "EquipmentPoolTransfer",
  metaInfo(){
       return {
         title : 'Shop Purchase Orders | FleetPro Application'
       }
    },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,
    action: '',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns: [
        {
            label: 'PO Header Type',
            field: 'po_header_type',
            fpFieldType:"option",
            filterable: true,
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "All", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                filterDropdownItems: [{text:'Shop',value:'item'},{text:'Sublet',value:'sublet_po'}],
                trigger: "enter" //only trigger on enter not on keyup
            },
        },
        {
            label: 'PO Number',
            field: 'po_no',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'PO Status',
            field: 'po_status',
            fpFieldType:"option",
            filterable: true,
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "All", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                filterDropdownItems: ["Accrued","Hold",'Open',"Partial","Processed",'Closed','Reserved','Cancelled'],
                trigger: "enter" //only trigger on enter not on keyup
            },
        },
        {
            label: 'PO Status Desc',
            field: 'po_status_desc',
            fpFieldType:"text",
            filterable: false,
            hidden:false,
            sortable:false
        },
        {
            label: 'PO Receipt Status',
            field: 'po_rec_status',
            fpFieldType:"option",
            filterable: true,
            hidden:false,
            filterOptions: { //
                enabled: false, // enable filter for this column
                placeholder: "All", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                filterDropdownItems: ['Good_received','Closed','Pending'],
                trigger: "enter" //only trigger on enter not on keyup
            },
        },
        {
            label: 'PO Receipt Status Desc',
            field: 'po_rec_status_desc',
            fpFieldType:"option",
            filterable: false,
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "All", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                filterDropdownItems: ['Open','Closed','Reserved','Sent'],
                trigger: "enter" //only trigger on enter not on keyup
            },
        },
        {
            label: 'PO Type',
            field: 'po_type',
            fpFieldType:"option",
            filterable: true,
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "All", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                filterDropdownItems: [{text:'Shop',value:'item'},{text:'Sublet',value:'sublet_po'}],
                trigger: "enter" //only trigger on enter not on keyup
            },
        },
        {
            label: 'PO Date',
            field: 'po_date',
            fpFieldType:"date",
            filterable: true,
            hidden:false
        },
        {
            label: 'PO Agent',
            field: 'po_agent',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'User Create',
            field: 'created_by',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Warehouse',
            field: 'location',
            fpFieldType:"option",
            filterable: true,
            hidden:false
        },
        {
            label: 'Vendor Name',
            field: 'vendor_name',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Vendor Number',
            field: 'vendor_code',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Prov/State Code',
            field: 'state',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'PO Line Number',
            field: 'po_line_number',
            fpFieldType:"integer",
            type : 'number',
            filterable: true,
            hidden:false
        },
        {
            label: 'Part Number',
            field: 'part_number',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Description',
            field: 'description',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Order Qty',
            field: 'order_qty',
            fpFieldType:"text",
            //type : 'number',
            filterable: true,
            hidden:false
        },
        {
            label: 'Cost Amount',
            field: 'cost_amount',
            fpFieldType:"integer",
            type : 'number',
            filterable: true,
            hidden:false
        },
        {
            label: 'Total Line',
            field: 'total_line',
            fpFieldType:"integer",
            //type : 'number',
            filterable: true,
            hidden:false
        },
        {
            label: 'Vendor Invoice Number',
            field: 'vendor_inv_no',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Invoice Date',
            field: 'invoice_date',
            fpFieldType:"date",
            filterable: true,
            hidden:false
        },
        {
            label: 'WO Number',
            field: 'workorder_no',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Unit Number',
            field: 'unit_no',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Receipt Qty',
            field: 'receipt_qty',
            fpFieldType:"integer",
            type : 'number',
            filterable: true,
            hidden:false
        },
        {
            label: 'Received Cost Amount',
            field: 'received_cost_amt',
            fpFieldType:"integer",
            type : 'number',
            filterable: true,
            hidden:false
        },
        {
            label: 'Receipt Total',
            field: 'receipt_total',
            fpFieldType:"integer",
            type : 'number',
            filterable: true,
            hidden:false
        },
        {
            label: 'Receiver Date',
            field: 'receiver_date',
            fpFieldType:"date",
            filterable: true,
            hidden:false
        },
        {
            label: 'Receiver Time',
            field: 'receiver_time',
            fpFieldType:"date",
            filterable: false,
            sortable: false,
            hidden:false
        },
        {
            label: 'Pay To Vendor',
            field: 'pay_to_vendor',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Quote Reference Number',
            field: 'quote_ref_no',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Quote Reference Date',
            field: 'quote_ref_date',
            fpFieldType:"date",
            filterable: true,
            hidden:false
        },
        {
            label: 'Special Order?',
            field: 'special_order',
            fpFieldType:"option",
            filterable: true,
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "All", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                filterDropdownItems: [{text:'Y',value:'yes'},{text:'N',value:'no'}],
                trigger: "enter" //only trigger on enter not on keyup
            },
        },
        {
            label: 'Special Order Unit',
            field: 'special_order_unit',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Receipt Date Greater Than Invoice Date?',
            field: 'receipt_gt_invoice',
            fpFieldType:"option",
            filterable: true,
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "All", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                filterDropdownItems: [{text:'Y',value:'yes'},{text:'N',value:'no'}],
                trigger: "enter" //only trigger on enter not on keyup
            },
        },
        {
            label: 'PO Create Date Greater Than Invoice Date?',
            field: 'po_gt_invoice',
            fpFieldType:"option",
            filterable: true,
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "All", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                filterDropdownItems: [{text:'Y',value:'yes'},{text:'N',value:'no'}],
                trigger: "enter" //only trigger on enter not on keyup
            },
        },
        {
            label: 'Review Dates?',
            field: 'review_dates',
            fpFieldType:"option",
            filterable: true,
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "All", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                filterDropdownItems: [{text:'Y',value:'yes'},{text:'N',value:'no'}],
                trigger: "enter" //only trigger on enter not on keyup
            },
        },
        {
            label: 'PO Create Date',
            field: 'po_create_date',
            fpFieldType:"date",
            filterable: true,
            hidden:false
        },
        {
            label: 'Outstanding',
            field: 'outstanding',
            fpFieldType:"option",
            filterable: true,
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "All", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                filterDropdownItems: [{text:'Y',value:'yes'},{text:'N',value:'no'}],
                trigger: "enter" //only trigger on enter not on keyup
            },
        },
        {
            label: 'Days Aging',
            field: 'days_aging',
            fpFieldType:"integer",
            type : 'number',
            filterable: true,
            hidden:false
        },
        {
            label: 'Diff. Pay To?',
            field: 'diff_pay_to',
            fpFieldType:"option",
            filterable: true,
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "All", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                filterDropdownItems: [{text:'Y',value:'yes'},{text:'N',value:'no'}],
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: 'Vendor City',
            field: 'vendor_city',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'User ID Create',
            field: 'user_id_create',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Program Create',
            field: 'program_create',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Date Created',
            field: 'date_created',
            fpFieldType:"date",
            filterable: true,
            hidden:false
        },
        {
            label: 'Time Created',
            field: 'time_created',
            filterable: true,
            fpFieldType:"date",
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Time Created", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: 'User Last Changed',
            field: 'user_last_changed',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Program Changed',
            field: 'program_changed',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Date Last Changed',
            field: 'date_last_changed',
            fpFieldType:"date",
            filterable: true,
            hidden:false
        },
        {
            label: 'Time Last Changed',
            field: 'time_last_changed',
            filterable: true,
            fpFieldType:"date",
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Time Created", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: 'PO Header Comments',
            field: 'po_header_comments',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Work Order Line Description',
            field: 'work_order_line_description',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Work Order VMRS Code',
            field: 'work_order_VMRS_code',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Packing Slip Number',
            field: 'packing_slip_number',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Unit Current Facility ID Code',
            field: 'location',
            fpFieldType:"option",
            filterable: true,
            hidden:false
        },
        {
            label: 'Facility Description',
            field: 'facility_description',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Product Category Code',
            field: 'product_category_code',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Voucher Company Nbr',
            field: 'voucher_company_nbr',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Voucher Number',
            field: 'voucher_number',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'Date Passed to Acctg ',
            field: 'date_passed_to_acctg',
            fpFieldType:"date",
            filterable: true,
            hidden:false
        },
        {
            label: 'Item Type Code',
            field: 'item_type_code',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'User Name Create',
            field: 'user_name_create',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },
        {
            label: 'User Name Last Changed',
            field: 'user_name_last_changed',
            fpFieldType:"text",
            filterable: true,
            hidden:false
        },

    ],
    batchProcess:0,
    batchNum:"",
  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'shop_purchase_order_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },

  methods:{
    cancelAll: function (cancelAll) {
      this.$refs.equipmentCurrentStatusTable.unselectAllInternal();
    },

    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      var selectedRows = [];
      var data = this.$refs['shopPurchaseOrderReport'].selectedRows;
      for ( var i = 0; i < data.length; i++ ) {
          selectedRows.push(this.$refs['shopPurchaseOrderReport'].selectedRows[i].id)
      }

      $.ajax({
        url: process.env.ROOT_API + "/report/shop-purchase-orders",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action,
          selectedAll:self.serverParams.selectedAll,
          selectedRows:selectedRows,
        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          if (data.status == "success") {

            if ( self.action == "export" ||  self.action == "export_queue") {

                if ( data.code == "201" ) {
                    alert(data.message);
                } else {

                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);

                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }

                }

                self.action = "list";
                self.loadList();
                return;
            } else {
              if (data.content.row != undefined) {
                self.rows = data.content.row;
              }
              self.totalRecords = data.content.totalRecords;
            }
          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'equipment-current-status')
        }
      });


    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/ShopPurchaseOrderReport.vue